import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const PasswordField = ({
  label,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  required = false,
  className = "",
  showStrength = false,
  strength = 0,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const getStrengthBarColor = () => {
    if (strength <= 2) return "bg-red-500";
    if (strength === 3) return "bg-yellow-500";
    return "bg-green-500";
  };

  const getStrengthText = () => {
    if (strength <= 2) return "Weak";
    if (strength === 3) return "Decent";
    return "Strong";
  };

  return (
    <div className={`mb-3 ${className}`}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          className={`w-full px-3 py-2 pr-10 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            error ? "border-red-500" : "border-gray-300"
          }`}
          {...props}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
        >
          {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
        </button>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      {showStrength && (
        <div className="mt-2">
          <div className="flex items-center justify-between text-sm">
            <span>Password strength:</span>
            <span className={getStrengthBarColor().replace('bg-', 'text-')}>
              {value ? getStrengthText() : ""}
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
            <div
              className={`h-2 rounded-full ${getStrengthBarColor()}`}
              style={{ width: `${(strength / 4) * 100}%` }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PasswordField; 